// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { HistoryEvent } from './historyEvent.zod.ts';

export const HistoryOut = zod.object({
  "events": zod.array(HistoryEvent),
  "page": zod.int(),
  "page_size": zod.int(),
  "total": zod.int()
});

export type HistoryOut = zod.input<typeof HistoryOut>;
export type HistoryOutOutput = zod.output<typeof HistoryOut>;
